var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1L9.94681 5.68068L15 6.0858L11.15 9.38373L12.3262 14.3148L8 11.6723L3.67376 14.3148L4.85 9.38373L1 6.0858L6.05319 5.68068L8 1Z",
    fill: "#FDC400"
  })));
};
export default SvgStarFilled;